export default __webpack_public_path__ + "static/media/drawerSuccess.38a44c79.svg";